import { createRoute } from '@tanstack/react-router';
import { Route as parentRoute } from '../../kiosk';
import { PlaceholderPage } from '@/components/placeholder/PlaceholderPage';

export const Route = createRoute({
  getParentRoute: () => parentRoute,
  path: '/preview/$id',
  component: ({ params }) => (
    <PlaceholderPage 
      title="Kiosk Preview" 
      description={`Preview of kiosk settings with ID: ${params.id}`}
    />
  ),
});
